var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "full-height",
      staticStyle: { padding: "20px", "padding-bottom": "0", height: "100%" },
    },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.panel,
            callback: function ($$v) {
              _vm.panel = $$v
            },
            expression: "panel",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "首頁輪播圖", name: "images" } }),
          _c("el-tab-pane", {
            attrs: { label: "hashtags集合", name: "hashtags" },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "padding-bottom": "0" } },
        [
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", disabled: _vm.listLoading },
                      on: { click: _vm.addData },
                    },
                    [_vm._v("建立")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "圖片", width: "500" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-image", {
                          staticStyle: { height: "50px" },
                          attrs: {
                            src: scope.row.fileInfo[0].files[0].url,
                            fit: "contain",
                            "preview-src-list": _vm.fileUrl(scope.row.fileInfo),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm.panel !== "hashtags"
                ? _c("el-table-column", {
                    attrs: { align: "center", label: "網址", width: "400" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.content))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3823322255
                    ),
                  })
                : _vm._e(),
              _vm.panel == "hashtags"
                ? _c("el-table-column", {
                    attrs: { align: "center", label: "標題", width: "110" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.title))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1808518502
                    ),
                  })
                : _vm._e(),
              _vm.panel == "hashtags"
                ? _c("el-table-column", {
                    attrs: { align: "center", label: "HashTags", width: "110" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.changeShow(scope.row.hashTags))
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2450194225
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { align: "center", label: "排序", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.sort))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "編輯", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.editData(scope.row)
                              },
                            },
                          },
                          [_vm._v("編輯")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "刪除", width: "150", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope)
                              },
                            },
                          },
                          [_vm._v("刪除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticStyle: { border: "2px solid #ccc" },
          attrs: {
            title: "編輯",
            visible: _vm.dialogFormVisible,
            width: "50%",
            top: "1%",
          },
          on: {
            closed: _vm.onDialogClosed,
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.formLoading,
                  expression: "formLoading",
                },
              ],
              staticClass: "box-card",
              attrs: { "body-style": { border: "1px solid #ccc" } },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form",
                        {
                          ref: "dynamicValidateForm",
                          attrs: { model: _vm.formData },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "圖片",
                                "label-width": _vm.formLabelWidth,
                              },
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("Upload", {
                                    ref: "uploadRef",
                                    attrs: {
                                      accept: ".jpg,.jpeg,.png",
                                      payload: _vm.formData,
                                      "data-obj": _vm.fileObj,
                                      limitText:
                                        _vm.panel == "images"
                                          ? "請同時上傳電腦版及手機版圖片，尺寸:電腦版1440x200、手機版320x200，手機版檔名須加上_mobile，須為.jpg,.jpeg,.png格式，限制不超過2000MB"
                                          : "圖片尺寸:100x100，須為.jpg,.jpeg,.png格式，限制不超過2000MB",
                                      "limit-file-count":
                                        _vm.panel == "images" ? 2 : 1,
                                      "use-drag": false,
                                      action: "ToursCombine/saveIndexCarousel",
                                      "auto-upload": false,
                                      "show-file-list": true,
                                      "form-on-loading-parent": _vm.formLoading,
                                      "btn-txt": "上傳",
                                      "before-file-list":
                                        _vm.formData.fileInfo &&
                                        _vm.formData.fileInfo.length
                                          ? _vm.formData.fileInfo[0].files
                                          : [],
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "網址",
                                "label-width": _vm.formLabelWidth,
                                prop: "content",
                                rules: [
                                  {
                                    validator: _vm.validateLink,
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { autocomplete: "off" },
                                model: {
                                  value: _vm.formData.content,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "content", $$v)
                                  },
                                  expression: "formData.content",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.panel == "hashtags"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "標題",
                                    "label-width": _vm.formLabelWidth,
                                    prop: "title",
                                    rules: [
                                      {
                                        required: true,
                                        message: "請輸入標題",
                                        trigger: "blur",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { autocomplete: "off" },
                                    model: {
                                      value: _vm.formData.title,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "title", $$v)
                                      },
                                      expression: "formData.title",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.panel == "hashtags"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "hashTags",
                                    "label-width": _vm.formLabelWidth,
                                    prop: "hashTags",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        multiple: "",
                                        filterable: "",
                                        remote: "",
                                        "reserve-keyword": "",
                                        placeholder: "請輸入關鍵字",
                                        "remote-method": _vm.remoteMethod,
                                        loading: _vm.loading,
                                        "no-data-text": "無資料",
                                        "value-key": "id",
                                      },
                                      model: {
                                        value: _vm.formData.hashTags,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "hashTags",
                                            $$v
                                          )
                                        },
                                        expression: "formData.hashTags",
                                      },
                                    },
                                    _vm._l(_vm.options, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.title,
                                          value: item,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "排序",
                                "label-width": _vm.formLabelWidth,
                                prop: "sort",
                                rules: [
                                  {
                                    required: true,
                                    message: "請輸入排序",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { autocomplete: "off", type: "number" },
                                model: {
                                  value: _vm.formData.sort,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "sort", $$v)
                                  },
                                  expression: "formData.sort",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveData("dynamicValidateForm")
                    },
                  },
                },
                [_vm._v("儲 存")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }